import allTrim from '@/utils/allTrim';

export default {
  currWorkspace: ({ workspaces, currWorkspaceIndex }) =>
    workspaces[currWorkspaceIndex],

  currFullName: (state, { currWorkspace: { title, firstName, lastName } }) =>
    allTrim(
      `${title ? title : ''} ${firstName ? firstName : ''} ${
        lastName ? lastName : ''
      }`,
    ),
};
